import React from 'react';
import { Card } from '@/components/ui/card';
import { ChevronRight, ImageIcon } from 'lucide-react';
import { PodcastEpisode } from '@/types/episode.types';
import { StatusBadge } from '@/components/StatusBadge';
import { formatRelativeDate } from '@/utils/dateFormat';

interface MobileEpisodeCardProps {
  episode: PodcastEpisode;
  onClick: () => void;
}

export const MobileEpisodeCard: React.FC<MobileEpisodeCardProps> = ({
  episode,
  onClick,
}) => {
  return (
    <Card
      className="p-3 cursor-pointer transition-all active:scale-[0.99] hover:bg-accent"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        {/* Artwork Thumbnail */}
        <div className="w-12 h-12 rounded overflow-hidden bg-muted flex-shrink-0 flex items-center justify-center">
          {episode.artworkThumbnail || episode.coverArtUrl ? (
            <img
              src={episode.artworkThumbnail || episode.coverArtUrl || ''}
              alt=""
              className="w-full h-full object-cover"
            />
          ) : (
            <ImageIcon className="h-5 w-5 text-muted-foreground" />
          )}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-sm truncate">{episode.title}</h3>
          <div className="flex items-center gap-2 mt-1">
            <StatusBadge status={episode.status} scheduledPublishDate={episode.scheduledPublishDate} />
            <span className="text-xs text-muted-foreground">
              {formatRelativeDate(episode.updatedAt)}
            </span>
          </div>
        </div>

        {/* Chevron */}
        <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      </div>
    </Card>
  );
};
